import ResetPasswordForm from '../../components/ResetPasswordPage/ResetPasswordForm/ResetPasswordForm';
import { getStaticProps } from '../../config/getProps';

export { getStaticProps };

export default ResetPasswordForm;
